import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createLoyaltyImportFileUrlRequest = {};
var _createLoyaltyImportFileUrlResponse = {};
var _createLoyaltyImportRequest = {};
var _createLoyaltyImportResponse = { loyaltyImport: '_loyaltyImport' };
var _deleteLoyaltyImportRequest = {};
var _deleteLoyaltyImportResponse = {};
var _executeLoyaltyImportRequest = {};
var _executeLoyaltyImportResponse = { loyaltyImport: '_loyaltyImport' };
var _getErrorFileDownloadUrlRequest = {};
var _getErrorFileDownloadUrlResponse = {};
var _getLoyaltyImportRequest = {};
var _getLoyaltyImportResponse = { loyaltyImport: '_loyaltyImport' };
var _loyaltyImport = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryLoyaltyImportsRequest = {};
var _queryLoyaltyImportsResponse = { loyaltyImports: '_loyaltyImport' };
function resolveWixLoyaltyImportsV1LoyaltyImportsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/loyalty-imports',
                destPath: '',
            },
            {
                srcPath: '/_api/loyalty-imports',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/loyalty-imports',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/loyalty-imports',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/loyalty-imports',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-imports',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates an import object based on an uploaded file.
 *
 * Call this method after uploading your file to the URL obtained from [Create Loyalty Import File Url](https://dev.wix.com/docs/rest/crm/loyalty-program/imports/create-loyalty-import-file-url).
 */
export function createLoyaltyImport(payload) {
    var _a = serializer(_createLoyaltyImportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLoyaltyImportResponse, {
        _loyaltyImport: _loyaltyImport,
    }).fromJSON;
    function __createLoyaltyImport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'POST',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.CreateLoyaltyImport',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLoyaltyImport.fromReq = fromReq;
    __createLoyaltyImport.__isAmbassador = true;
    return __createLoyaltyImport;
}
/** Retrieves a loyalty import. */
export function getLoyaltyImport(payload) {
    var _a = serializer(_getLoyaltyImportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyImportResponse, {
        _loyaltyImport: _loyaltyImport,
    }).fromJSON;
    function __getLoyaltyImport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'GET',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.GetLoyaltyImport',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyImport.fromReq = fromReq;
    __getLoyaltyImport.__isAmbassador = true;
    return __getLoyaltyImport;
}
/**
 * Retrieves the download URL for the error file of a failed loyalty import.
 *
 * If an import fails, the `importResult.errorFileExists` field in the `LoyaltyImport` object is set to `true`.
 *
 * Use this method to get the URL of the error file, which contains details about which items couldn't be imported and why.
 */
export function getErrorFileDownloadUrl(payload) {
    var _a = serializer(_getErrorFileDownloadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getErrorFileDownloadUrlResponse, {}).fromJSON;
    function __getErrorFileDownloadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'GET',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.GetErrorFileDownloadUrl',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports/error-file-download-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getErrorFileDownloadUrl.fromReq = fromReq;
    __getErrorFileDownloadUrl.__isAmbassador = true;
    return __getErrorFileDownloadUrl;
}
/**
 * Starts the actual import process for a loyalty import.
 *
 * Call this method after the loyalty import object reaches the `PARSED` status.
 */
export function executeLoyaltyImport(payload) {
    var _a = serializer(_executeLoyaltyImportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_executeLoyaltyImportResponse, {
        _loyaltyImport: _loyaltyImport,
    }).fromJSON;
    function __executeLoyaltyImport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'POST',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.ExecuteLoyaltyImport',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports/execute',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __executeLoyaltyImport.fromReq = fromReq;
    __executeLoyaltyImport.__isAmbassador = true;
    return __executeLoyaltyImport;
}
/**
 * Creates a URL for uploading a loyalty import file.
 *
 * This method is the first step in the loyalty import process. It returns a file path and an upload URL, which you'll use in subsequent steps of the import process.
 */
export function createLoyaltyImportFileUrl(payload) {
    var _a = serializer(_createLoyaltyImportFileUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLoyaltyImportFileUrlResponse, {}).fromJSON;
    function __createLoyaltyImportFileUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'POST',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.CreateLoyaltyImportFileUrl',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports/wixmp-upload-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLoyaltyImportFileUrl.fromReq = fromReq;
    __createLoyaltyImportFileUrl.__isAmbassador = true;
    return __createLoyaltyImportFileUrl;
}
/**
 * Retrieves a list of loyalty imports, given the provided paging, filtering, and sorting.
 *
 * To learn about working with query endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryLoyaltyImports(payload) {
    var _a = serializer(_queryLoyaltyImportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLoyaltyImportsResponse, {
        _loyaltyImport: _loyaltyImport,
    }).fromJSON;
    function __queryLoyaltyImports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'POST',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.QueryLoyaltyImports',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLoyaltyImports.fromReq = fromReq;
    __queryLoyaltyImports.__isAmbassador = true;
    return __queryLoyaltyImports;
}
/** Deletes a loyalty import. */
export function deleteLoyaltyImport(payload) {
    var _a = serializer(_deleteLoyaltyImportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLoyaltyImportResponse, {}).fromJSON;
    function __deleteLoyaltyImport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.imports.v1.loyalty_import',
            method: 'DELETE',
            methodFqn: 'wix.loyalty.imports.v1.LoyaltyImports.DeleteLoyaltyImport',
            url: resolveWixLoyaltyImportsV1LoyaltyImportsUrl({
                protoPath: '/v1/loyalty-imports',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLoyaltyImport.fromReq = fromReq;
    __deleteLoyaltyImport.__isAmbassador = true;
    return __deleteLoyaltyImport;
}
//# sourceMappingURL=http.impl.js.map